import {Timeline, TimelineProps} from "../Timeline/Timeline";
import {
  ShiftTimeline as ShiftTimelineData,
  ShiftTimelineEvent,
  TransportShiftTimelineEvent
} from "@ots-frontend/ots-data";
import {TransportTimelineItem} from "./TransportTimelineItem";
import {StartTimelineItem} from "./StartTimelineItem";
import {useMemo} from "react";
import {EndTimelineItem} from "./EndTimelineItem";
import {GeofenceEntryTimelineItem} from "./GeofenceEntryTimelineItem";
import {GeofenceExitTimelineItem} from "./GeofenceExitTimelineItem";

const getTimelineItem = (
  event: ShiftTimelineEvent,
  onTimelineItemClick: ((event: ShiftTimelineEvent) => void) | undefined,
  onTransportChecked: ((event: TransportShiftTimelineEvent, value: boolean) => void) | undefined): React.ReactNode => {
  switch (event.type) {
    case "SHIFT_START":
      return (
        <Timeline.Item
          key={`start-${event.id}`}
          title={<StartTimelineItem.Title/>}
          bullet={<StartTimelineItem.Bullet event={event} onClick={onTimelineItemClick}/>}
        >
          <StartTimelineItem event={event}/>
        </Timeline.Item>
      );
    case "GEOFENCE_ENTRY":
      return (
        <Timeline.Item
          key={`geofence-entry-${event.id}`}
          title={<GeofenceEntryTimelineItem.Title/>}
          bullet={<GeofenceEntryTimelineItem.Bullet event={event} onClick={onTimelineItemClick}/>}
        >
          <GeofenceEntryTimelineItem event={event}/>
        </Timeline.Item>
      );
    case "GEOFENCE_EXIT":
      return (
        <Timeline.Item
          key={`geofence-exit-${event.id}`}
          title={<GeofenceExitTimelineItem.Title/>}
          bullet={<GeofenceExitTimelineItem.Bullet event={event} onClick={onTimelineItemClick}/>}
        >
          <GeofenceExitTimelineItem event={event}/>
        </Timeline.Item>
      );
    case 'TRANSPORT':
      return (
        <Timeline.Item
          key={`transport-${event.id}`}
          title={<TransportTimelineItem.Title event={event}/>}
          bullet={<TransportTimelineItem.Bullet event={event} onClick={onTimelineItemClick}/>}
        >
          <TransportTimelineItem event={event} onChecked={onTransportChecked}/>
        </Timeline.Item>
      );
    case "SHIFT_END":
      return (
        <Timeline.Item
          key={`end-${event.id}`}
          title={<EndTimelineItem.Title/>}
          bullet={<EndTimelineItem.Bullet event={event} onClick={onTimelineItemClick}/>}
        >
          <EndTimelineItem event={event}/>
        </Timeline.Item>
      );
    default:
      return undefined;
  }
};

export type BaseShiftTimelineProps = Omit<TimelineProps, 'children'> & {
  timeline: ShiftTimelineData
  onTimelineItemClick?: (event: ShiftTimelineEvent) => void
  onTransportChecked?: (event: TransportShiftTimelineEvent, value: boolean) => void
}

export const BaseShiftTimeline = (props: BaseShiftTimelineProps) => {
  const {timeline, onTimelineItemClick, onTransportChecked, ...rest} = props

  const nodes = useMemo(() => timeline.events.map(
      (e) => getTimelineItem(e, onTimelineItemClick, onTransportChecked)),
    [timeline.events, onTimelineItemClick, onTransportChecked]);

  return (
    <Timeline {...rest}>
      {nodes.map((n) => {
        return n;
      })}
    </Timeline>
  )
}
